import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@/.sourceflow/news.json";
import tags from "@/.sourceflow/news_tag.json";
import { sortByDate } from "@/functions/sortByDate";

export const useBlogs = ({ locale, filters = null, limit = null } = {}) => {
  let collection = sortByDate(useSourceFlowCollection(data), "publish_date");

  if (filters && filters.length > 0) {
    let filterTags = tags?.category_values?.filter((tag) => tag.id.includes(filters)).map((tag) => tag.title.en);
    collection = collection.filter((article) => article?.tag.some((filter) => filter?.includes(filterTags)));
  }

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default useBlogs;